export default from './infinite-list';



// WEBPACK FOOTER //
// ./app/components/infinite-list/index.js